var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"value":_vm.showValue,"disabled":!_vm.tip,"content":_vm.tip,"placement":"top-end"}},[_c('div',{directives:[{name:"track",rawName:"v-track",value:({
      type: 'click',
      name: `${_vm.$route.params.type || 'phone'}.${
        _vm.$route.params.step || 'account'
      }.sms`,
    }),expression:"{\n      type: 'click',\n      name: `${$route.params.type || 'phone'}.${\n        $route.params.step || 'account'\n      }.sms`,\n    }"}],class:[
      _vm.isActive ? 'active-sms' : '',
      _vm.timeCount ? 'disabled' : '',
      'el-input-add-btn',
      _vm.theme ? 'theme--' + _vm.theme : '',
    ],on:{"click":_vm.handle}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }